import getFixedRevertingRate from './getFixedRevertingRate';

const lvrValues = {
  "special": "Up to 60%",
  "regular": "60% to 80%",
  "poor": "Above 80%"
}

const objectiveValues = {
  "live": "Live in",
  "invest": "Invest"
}

const fixedRatePeriodValues = {
  "fixed1year": 1,
  "fixed2year": 2,
  "fixed3year": 3,
  "fixed5year": 5,
}

function getCalculationInputsFromURL(url, inputArray) {
  const params = (new URL(url)).searchParams
  const inputValues = inputArray.map((inputKey) => {
    return params.get(inputKey)
  })

  const productConfig = {};
  const paramsAsObject = inputArray.reduce((obj, inputKey, i) => {
    if (inputKey === 'interestType') {
      obj[inputKey] = inputValues[i]
    } else if (inputKey === 'matchingLoans'){
      obj[inputKey] = parseFloat(inputValues[i]) / 100
    } else if (inputKey === 'lvr') {
      obj[inputKey] = lvrValues[inputValues[i]]
      productConfig[inputKey] = inputValues[i]
    } else if (inputKey === 'objective') {
      obj[inputKey] = objectiveValues[inputValues[i]]
      productConfig[inputKey] = inputValues[i]
    } else if (inputKey === 'fixedRatePeriod'){
      obj[inputKey] = fixedRatePeriodValues[inputValues[i]]
    } else {
      obj[inputKey] = parseFloat(inputValues[i])
    }
    return obj
  }, {})
  const fixedRevertingRate = getFixedRevertingRate(productConfig.lvr, productConfig.objective) / 100
  return {
    fixedRevertingRate,
    ...paramsAsObject
  }
}

export default getCalculationInputsFromURL
